'use strict';
var carswip = carswip || {};

const iphoneMask = '';
const iphoneImage = '';

carswip.hero = carswip.hero || function () {
    
	function init() {
        if(window.innerWidth > 992) {

            const imagewrapper = document.getElementById('hero-image-wrapper');

            if(imagewrapper) {
            const iphoneMask = document.getElementById('iphone-mask');
            const iphoneImage = document.getElementById('iphone-image');
            const mouseAreaRect = imagewrapper.getBoundingClientRect();
            const mouseAreaHeight = mouseAreaRect.height;
            // const mouseAreaWidth = mouseAreaRect.width;
            const mouseAreaLeft = mouseAreaRect.left - 100;
            const mouseAreaRight = mouseAreaRect.right;
            const mouseAreaTop = mouseAreaRect.top;
            const mouseAreaBottom = mouseAreaRect.bottom;
            const iphoneHeight = iphoneImage.getBoundingClientRect().height;
            const iphoneWidth = iphoneImage.getBoundingClientRect().width;
            let mouseX = 0;
            let mouseY = 0;
            let cursorX = 0;
            let cursorY = 0;
            let speed = 1; // change to increase the ease
            
                window.addEventListener('mousemove', (evt) => {
                    const x = (+(window.innerWidth / 2 - evt.pageX)) * 0.47;
                    const y = +(window.innerHeight / 2 - evt.pageY) / 4;
                    let newPosX = x + iphoneWidth;
                    let newPosY = y + iphoneHeight/2;

                    if(evt.pageY < mouseAreaBottom && evt.pageX < (mouseAreaRight + iphoneWidth) && evt.pageX > mouseAreaLeft) {
                        iphoneMask.style.transition = '';
                        iphoneImage.style.transition = '';
                        iphoneMask.style.transform = `translate3d(${-newPosX}px, ${-newPosY}px, 0)`;
                        iphoneImage.style.transform = `translate3d(${-newPosX}px, ${-newPosY}px, 0)`;
                    } else {
                        iphoneMask.style.transition = 'all .3s ease';
                        iphoneImage.style.transition = 'all .3s ease';
                        iphoneMask.style.transform = '';
                        iphoneImage.style.transform = '';
                    }
                });
            }
        }
	}

	return {
		init : init
	};
}();